import styles from 'legacy/common/components/form/Form.module.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import FormWrapper from '../FormWrapper';

type LoginMethodsListProps = {
  currentMethod: 'email' | 'phone';
  onSelectMethod: (method: 'email' | 'phone') => void;
  onBack: () => void;
  isModal?: boolean;
};

const EmailIcon = () => (
  <svg
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);

const PhoneIcon = () => (
  <svg
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
    <path d="M12 18h.01" />
  </svg>
);

const LoginMethodsList: React.FC<LoginMethodsListProps> = ({
  currentMethod,
  onSelectMethod,
  onBack,
  isModal = false
}) => {
  const { t } = useTranslation('auth');

  const methods = [
    { 
      key: 'email', 
      label: t('loginForm.emailLabel'),
      icon: <EmailIcon />
    },
    { 
      key: 'phone', 
      label: t('loginForm.phoneNumberLabel'),
      icon: <PhoneIcon />
    }
  ];

  const availableMethods = methods.filter(
    (method) => method.key !== currentMethod
  );

  return (
    <FormWrapper
      title={t('loginForm.selectLoginMethod')}
      showBack
      onBackClick={onBack}
      isModal={isModal}
    >
      <div className={styles.group}>
        <div className="flex flex-col gap-3">
          {availableMethods.map((method) => (
            <button
              key={method.key}
              type="button"
              onClick={() => onSelectMethod(method.key as 'email' | 'phone')}
              className={classnames(
                'inline-flex items-center justify-center gap-2.5 px-6 py-3',
                'rounded-full border border-gray-300',
                'bg-white text-gray-900',
                'text-sm font-medium',
                'transition-all duration-200',
                'hover:bg-gray-50 hover:border-gray-400',
                'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
                'active:scale-[0.98]'
              )}
              data-testid={`method-option-${method.key}`}
            >
              <div className="flex-shrink-0 text-gray-700">
                {method.icon}
              </div>
              <span>{method.label}</span>
            </button>
          ))}
        </div>
      </div>
    </FormWrapper>
  );
};

export default LoginMethodsList;

